// goog.require('cljs.core') ??

// Allows TypeScript code to access exported ClojureScript symbols, published using `goog.exportSymbol`.
// To make this work *in production*, there MUST be a corresponding call to `goog.exportSymbol` from ClojureScript.
// Grep for goog.exportSymbol to find some examples.
// Gotcha: because the page script load order is (1) esm_bundle.js (2) ladder/main.js, resolveGoogExport cannot be
// called from file scope at read time, it can only be called inside a function which is evaluated AFTER ladder/main.js
// is loaded.
export function resolveGoogExport(dotString: string): any { // AI
    const parts = dotString.split('.');
    let G: any = globalThis; // i.e., `window`
    for (const part of parts) {
        if (G === undefined || G === null || typeof G !== 'object' || !(part in G)) {
            return undefined; // or throw, unresolved path
        }
        G = G[part];
    }
    return G;
}

export function jsclj (x) {
    let {js__GT_clj, keyword} = resolveGoogExport('cljs.core');
    return js__GT_clj(x, keyword('keywordize-keys'), true);
}

export function cljjs (x) {
    let {clj__GT_js, keyword, subs, pr_str} = resolveGoogExport('cljs.core');
    return clj__GT_js(x, keyword('keyword-fn'), x => subs(pr_str(x), 1)); // drop \:, keep "ns/name"
}

export function cljpr (x) {
    let {cljpr} = resolveGoogExport('dgetz.tsclj2');
    return cljpr(x);
}

// cljs.core exports

export function keyword (...args) {
    let {keyword} = resolveGoogExport('cljs.core');
    return keyword(...args);
}


export function cljsSet (xs: Array<any>) {
    let {set, array_seq} = resolveGoogExport('cljs.core');

    return set(array_seq(xs));
}
// export function assoc (...args) {
//     let {assoc} = resolveGoogExport('cljs.core');
//     return assoc(...args);
// }

export function merge (...args) {
    let {merge} = resolveGoogExport('cljs.core');
    return merge(...args);
}

export function hash_map (...args) {
    let {hash_map} = resolveGoogExport('cljs.core');
    return hash_map(...args);
}
